import { render, staticRenderFns } from "./ViewDetailSort.vue?vue&type=template&id=1f5e369e&scoped=true&"
import script from "./ViewDetailSort.vue?vue&type=script&lang=js&"
export * from "./ViewDetailSort.vue?vue&type=script&lang=js&"
import style0 from "./ViewDetailSort.vue?vue&type=style&index=0&id=1f5e369e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5e369e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VRow,VSimpleTable,VSpacer})
